import { CompassIcon, SplitIcon, TrendingUpIcon, ZapIcon, FlagIcon } from 'lucide-react';

export const infoSources = [
  'Des séances de natation',
  'Des entraînements de vélo',
  'Des plans de course à pied',
  'Des conseils nutritionnels',
  'Des recommandations de récupération',
  'Des checklists pour le jour de la course',
];

export const selfQuestions = [
  "Est-ce que je m'entraîne suffisamment ?",
  "Est-ce que j'en fais trop ?",
  'Que dois-je prévoir cette semaine ?',
  'Comment équilibrer la natation, le vélo et la course à pied ?',
  "Quand dois-je augmenter l'intensité ?",
  'Quand dois-je privilégier la récupération ?',
  'Comment organiser mon ravitaillement pendant les longues séances ?',
  'Comment savoir si je progresse réellement ?',
  'Comment préparer efficacement ma semaine de course ?',
];

export const painPoints: {
  icon: typeof CompassIcon;
  title: string;
  body: string[];
  list?: string[];
  resolve?: string;
}[] = [
  {
    icon: CompassIcon,
    title: 'Vous ne savez pas par où commencer',
    body: [
      'Un triathlon distance complète demande des mois de préparation.',
      "Sans structure claire, il est facile de passer d'une séance à une autre sans comprendre comment chaque étape s'intègre dans une préparation cohérente.",
    ],
    resolve: 'LE SYSTÈME TRIATHLON LONGUE DISTANCE™ organise votre parcours en six phases progressives.',
  },
  {
    icon: SplitIcon,
    title: 'Vos trois disciplines semblent déconnectées',
    body: [
      'Natation. Vélo. Course à pied. Trois disciplines. Une seule course.',
      'Votre préparation doit relier ces trois activités plutôt que de les traiter comme des objectifs complètement indépendants.',
    ],
    resolve: "Le système vous aide à réfléchir à leur organisation dans le cadre d'une préparation globale.",
  },
  {
    icon: TrendingUpIcon,
    title: 'Vous ne savez pas si vous progressez réellement',
    body: [
      "S'entraîner davantage ne signifie pas automatiquement s'entraîner plus efficacement.",
      "Sans méthode pour suivre vos séances, votre régularité et votre évolution, il peut être difficile de comprendre ce qui fonctionne et ce qui mérite d'être ajusté.",
    ],
    resolve: 'Le carnet de suivi vous aide à enregistrer vos entraînements et à observer votre progression.',
  },
  {
    icon: ZapIcon,
    title: 'Vous ne savez pas comment organiser votre ravitaillement',
    body: [
      "Une épreuve de longue distance demande une préparation adaptée à la durée de l'effort. L'entraînement n'est qu'une partie de l'équation.",
      "La nutrition, l'hydratation et l'organisation du ravitaillement prennent également une place importante à mesure que la durée de l'effort augmente.",
    ],
    resolve: 'Le guide pratique vous aide à structurer cette partie de votre préparation.',
  },
  {
    icon: FlagIcon,
    title: 'Vous appréhendez la semaine de course',
    body: ["Vous pouvez passer des mois à vous entraîner et arriver malgré tout à la dernière semaine en vous demandant :"],
    list: [
      'Que dois-je emporter ?',
      'Que dois-je préparer la veille ?',
      'Comment organiser le matin de la course ?',
      'Ai-je vérifié mon équipement ?',
      'Comment préparer les transitions ?',
      'Comment organiser les différentes étapes de mon épreuve ?',
    ],
    resolve: 'Une course bien préparée ne commence pas sur la ligne de départ. Elle commence par une préparation organisée.',
  },
];
